import React, {useState} from "react";
import StateModalModel from "../../../../components/Modal/Model/StateModalModel";
import ModalComponents from "../../../../components/Modal/Modal";
import ChangePasswordModal from "./ChangePasswordModal/ChangePasswordModal";
import {useTranslation} from "react-i18next";

export default function ChangePassword() {
    const {t} = useTranslation();
    const [stateModal, setStateModal] = useState<StateModalModel>({
        body: <ChangePasswordModal/>,
        closeLabel: "",
        show: false,
        submit(): void {
        },
        submitLabel: "",
        modalClassName: 'change-password-admin-modal',
        title: ""
    })

    return (
        <>
            <section>
                <p>{t("setting.password")}</p>
                <button type="submit" onClick={() => setStateModal({...stateModal, show: true})}>
                    {t("setting.changePassword")}
                </button>
            </section>
            <ModalComponents state={stateModal} setState={setStateModal}/>
        </>
    )
}